<template>
  <v-layout align-center column>
    <h1 class="Section-Title-a">Our Values</h1>
    <v-row justify="center" class="row-spacing">
      <v-col>
        <div class="Vission-box">
          <v-skeleton-loader
            type="image"
            class="Vission"
            v-if="!isImgLoaded"
          ></v-skeleton-loader>
          <img
            src="../../assets/TentangKami/vission.png"
            class="Vission"
            @load="onImgLoad"
          />

          <p class="title">Our Vission</p>
          <p class="Desc">
            Menjadi platform Peer-to-peer Fintech Lending terdepan di Indonesia.
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="Mission">
          <v-skeleton-loader
            type="image"
            class="Mission-Icon"
            v-if="!isImgLoaded"
          ></v-skeleton-loader>
          <img
            src="../../assets/TentangKami/mission.png"
            class="Mission-Icon"
            @load="onImgLoad"
          />
          <p class="title">Our Mission</p>
          <p class="Desc">
            Membangun platform pinjaman digital memfasilitasi konsumen yang
            kurang terlayani & bisnis di Indonesia.
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="Goals">
          <v-skeleton-loader
            type="image"
            class="Goal-Icon"
            v-if="!isImgLoaded"
          ></v-skeleton-loader>
          <img
            src="../../assets/TentangKami/goal.png"
            class="Goal-Icon"
            @load="onImgLoad"
          />

          <p class="title">Our Goals</p>
          <p class="Desc">
            Menutup gap inklusi keuangan untuk berkontribusi memajukan
            Indonesia.
          </p>
        </div>
      </v-col>
    </v-row>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>
<style scoped>
.Section-Title-a {
  width: 328px;
  height: 23px;
  flex-grow: 0;
  margin: 50px 0 32px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.h1 {
  width: 135px;
  height: 30px;
  flex-grow: 0;
  margin: 0 172px 56px 171px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Icons_Cerdas {
  width: 80px;
  height: 73.4px;
  padding: 0 0 0px;
}
.Vission-box {
  width: 285px;
  height: 162px;
  flex-grow: 0;
  margin: 0px auto 26px auto;
}
.Vission {
  width: 80px;
  height: 80px;
  align-self: center;
  flex-grow: 0;
  margin: 0 103px 8px 102px;
  padding: 3.3px 0 3.3px;
}
.Vector {
  width: 51.6px;
  height: 60.9px;
  flex-grow: 0;
  margin: 2.7px 4.9px 9.7px 4.5px;
  padding: 14px 16.6px 22.9px 17px;
  box-shadow: 0 12px 25px 0 rgba(255, 190, 122, 0.35);
  background-color: #ffbe7a;
}
.title {
  height: 20px;
  flex-grow: 0;
  margin: 8px auto 10px auto;
  font-family: Sora;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  width: 285px;
  flex-grow: 0;
  margin: 10px auto 0 auto;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Mission {
  width: 285px;
  height: 188px;
  flex-grow: 0;
  margin: 0px auto 0 auto;
}

.Mission-Icon {
  width: 80px;
  height: 80px;
  align-self: center;
  flex-grow: 0;
  margin: 0 102px 12px 103px;
  padding: 6px 6px 6px 6px;
}
.Goals {
  width: 285px;
  height: 166px;
  flex-grow: 0;
  margin: 0px auto 26px auto;
}

.Goal-Icon {
  width: 80px;
  height: 80px;
  flex-grow: 0;
  margin: 0 102px 12px 103px;
  padding: 6px 6px 5.9px 6px;
}

.row-spacing {
  padding-bottom: 50px;
}
</style>
